export enum MediaErrorCode {
	DECODE = 3
}

export const NotAllowedError = 'NotAllowedError';
